// @ts-nocheck
/* eslint-disable react/prop-types */
import React, { useMemo, useEffect,createContext,useContext } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import InputLabel from '@mui/material/InputLabel';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import InputBase from '@mui/material/InputBase';
import { styled, alpha } from '@mui/material/styles';
import { visuallyHidden } from '@mui/utils';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Link, useLocation  } from 'react-router-dom';
//import Ts from "./TS.tsx";
import {useIntl  , FormattedMessage } from 'react-intl';
import ReactGA from "react-ga4";
import Refresh from './components/refresh';
import {LoginContext,AuthContext,LoadingContext,InfoPrewContext} from '../Default';
import {
  MRT_EditActionButtons,
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_ColumnDef,
} from 'material-react-table';
import {  colors } from '@mui/material';
//import { data, type Person } from './makeData';
import {type C2List,type Notice}  from "./data/tdb_c2";
import './TS.css';
import Chip from '@mui/material/Chip';
import { MRT_Localization_JA } from 'material-react-table/locales/ja';
import { MRT_Localization_EN } from 'material-react-table/locales/en';
import {stix} from './data/tdb_c2.tsx';
import logo from '../../TIP_tate.svg';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import {
  Tooltip,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Paper, { PaperProps } from '@mui/material/Paper';
import Draggable from 'react-draggable';
import CloseIcon from '@mui/icons-material/Close';
import dayjs, { Dayjs } from 'dayjs';
//import {RefreshContext} from './SearchResult';
// Google Analytics 測定 ID を入力して設定
ReactGA.initialize(process.env.REACT_APP_GA_KEY);
// const Item = styled(Paper)(({ theme }) => ({
//   backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
//   ...theme.typography.body2,
//   padding: theme.spacing(1),
//   textAlign: 'center',
//   color: theme.palette.text.secondary,
// }));
//export const RefreshContext = createContext();
const handleReady = () => {

};
const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}));
const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  width: '100%',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}));
const StyledBox = styled('div')(({ theme }) => ({
  alignSelf: 'center',
  width: '100%',
  height: 400,
  marginTop: theme.spacing(8),
  borderRadius: theme.shape.borderRadius,
  outline: '1px solid',
  boxShadow: '0 0 12px 8px hsla(220, 25%, 80%, 0.2)',
  backgroundImage: `url(${'/static/images/templates/templates-images/hero-light.png'})`,
  outlineColor: 'hsla(220, 25%, 80%, 0.5)',
  backgroundSize: 'cover',
  [theme.breakpoints.up('sm')]: {
    marginTop: theme.spacing(10),
    height: 700,
  },
  ...theme.applyStyles('dark', {
    boxShadow: '0 0 24px 12px hsla(210, 100%, 25%, 0.2)',
    backgroundImage: `url(${'/static/images/templates/templates-images/hero-dark.png'})`,
    outlineColor: 'hsla(210, 100%, 80%, 0.1)',
  }),
}));
const styles = (theme: { spacing: { unit: number; }; shape: { borderRadius: any; }; breakpoints: { up: (arg0: string) => any; }; transitions: { create: (arg0: string) => any; }; }) => ({
  root: {
  },
  textField: {
      marginLeft: theme.spacing.unit,
      marginRight: theme.spacing.unit,
      width: 200,
  },
  search: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      '&:hover': {
      },
      marginLeft: 0,
      width: '100%',
      [theme.breakpoints.up('sm')]: {
          marginLeft: theme.spacing.unit,
          width: 'auto',
      },
  },
  searchIcon: {
      width: theme.spacing.unit * 9,
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
  },
  inputRoot: {
      color: 'inherit',
      width: '100%',
  },
  inputInput: {
      paddingTop: theme.spacing.unit,
      paddingRight: theme.spacing.unit,
      paddingBottom: theme.spacing.unit,
      paddingLeft: theme.spacing.unit * 10,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('sm')]: {
          width: 120,
          '&:focus': {
              width: 200,
          },
      },
  },
});
const validateRequired = (value: string) => !!value.length;
function isScriptAlreadyInserted(scriptElement) {
  return Array.from(document.querySelectorAll('script')).some(s => s.src === scriptElement.src)
}
function validateUser(user: User) {
  return {
    name: !validateRequired(user.disp_type)
      ? '必須です'
      : '',
  };
}

export default function ColumnManage() {
  const intl = useIntl();
  let locale;
  if(intl.locale == "ja"){
    locale = MRT_Localization_JA
  }else{
    locale = MRT_Localization_EN
  }
  const location = useLocation();
  const [category, setCategory] = React.useState(location.state!==null&&location.state.hasOwnProperty("category") ? location.state["category"] : "0");
  const [keyword, setKeyword] = React.useState(location.state!==null&&location.state.hasOwnProperty("keyword") ? location.state["keyword"] : "");
  //const [refreshKey, setRefreshKey] = React.useState(0);
  //const [isActive, setIsActive] = useState(false);
  //const [category] = React.useState(location.state["category"]);
  //const [keyword] = React.useState(location.state["keyword"]);
  const [posts,setPosts] = React.useState<Post[]>([]);
  const [postsSeo,setPostsSeo] = React.useState<Post[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [open5, setOpen5] = React.useState(true);
  const {login,setLogain} = useContext(LoginContext);
  const {auth,setAuth} = useContext(AuthContext);
  const {loading,setLoading} = useContext(LoadingContext);
  const {noticeTitle,setNoticeTitle,noticeMsg,setNoticeMsg,noticeMsgOpen,setNoticeMsgOpen,setNoticeDate} = useContext(InfoPrewContext);
  const [reload,setReload] = React.useState(0);
  const [keyword2,setKeyword2] = React.useState(location.state!==null&&location.state.hasOwnProperty("keyword") ? location.state["keyword"] : "新着コラム");
  const [checked1, setChecked1] = React.useState(false);
  const [checked2, setChecked2] = React.useState( false);
  const [defaultValue1, setDefaultValue1] = React.useState("aaa");
  const [validationErrors, setValidationErrors] = React.useState<
    Record<string, string | undefined>
  >({});


  // const value = {
  //   refreshKey,
  //   setRefreshKey,
  // };
  const handleChangeCheckBox1 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked1(event.target.checked);
  };

  const handleChangeCheckBox2 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked2(event.target.checked);
  };
  const handleChange = (event:SelectChangeEvent) => {
    setCategory(event.target.value);
    
  }
  const handleChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    setKeyword(event.target.value);
  }
    const handleChangedefaultInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDefaultValue1(event.target.value);
  }
  
  const createColumn = () => {
    const cc = document.getElementById("createColumn");
    cc?.click();
    
  }
  const reloadChange = () => {
    if(keyword==""){
      setKeyword2("SEO管理");
    }else{
      setKeyword2(keyword);
    }
    const i = reload+1;
    setReload(i);
  }

  const params = { // 渡したいパラメータをJSON形式で書く
      category: category,
      keyword: keyword
    };
  var getParams = new URLSearchParams(params);
   // TextfieldとButtonIconを合体させたコンポーネントの作成
 const AddButton = () => {
  const addButtonClick = () => {

    // document.getElementById("demo-form").submit();
        ReactGA.event({
      category: "Search Button",
      action: "Search Button",
      label: keyword, // Optional
    });
    //const aaa = document.getElementById("sc");
    //aaa?.click();
    reloadChange();
     //setRefreshKey(old => old + 1)
  };
    return (
    <IconButton onClick={() => addButtonClick()}>
      <SearchIcon />
    </IconButton>
  );
};
  //const {refreshKey, setRefreshKey} = useContext(RefreshContext);
    const resData = async (): Promise<Post[]> => {
    const url = process.env.REACT_APP_SEO_API_URL;
    try{
      let bodyData;
      if(keyword == ""){
      bodyData= {
      category: "16",
      keyword: keyword
    };
      }else if(keyword.indexOf("#") === 0){
        const keywordSub = keyword.replace("#","");
      bodyData= {
      category: "16",
      keyword: keywordSub
    };
      }else{
      bodyData= {
      category: "16",
      keyword: keyword
      };
      }

  var getParams = new URLSearchParams(params);
   const headers = new Headers({
            "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
            'Access-Control-Allow-Credentials': 'true'
        });
  var params_str = params.toString();
  setLoading(true);
  return fetch(url , {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(bodyData)
    })
    .then((response) => {
      if (!response.ok ){
        setLoading(false);
        throw new Error('status is not 200');
      }
      return response.json();
    })
    .then(jsondata => {
      setLoading(false);
      return jsondata;
    })
    .catch(error => {
      setLoading(false);
    });;
    setLoading(false);
    }catch{
      setLoading(false);
    }
};


  useEffect(() => {
    (async function () {
      var res =[];
      const data = await resData();
      setPosts(data);
      setLoading(false);
    })();
   }, [reload]);
     //CREATE action
  const handleCreateUser: MRT_TableOptions<Notice>['onCreatingRowSave'] = async ({
    values,
    table,
  }) => {
    const newValidationErrors = validateUser(values);
    if (Object.values(newValidationErrors).some((error) => error)) {
      setValidationErrors(newValidationErrors);
    setMsg("langID00075");
    setMsgOpenErr(true);
    setTimeout(() => {
      setMsgOpenErr(false);
    }, 5000);
      return;
    }
    setValidationErrors({});
    const url = process.env.REACT_APP_SEO_API_URL;
    try{
    const bodyData = {
      category: "17",
      disp_type:values.disp_type,
      keyword:values.keyword
    };
  var getParams = new URLSearchParams(params);
   const headers = new Headers({
            "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
            'Access-Control-Allow-Credentials': 'true'
        });
  var params_str = params.toString();
  setLoading(true);
  return fetch(url , {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(bodyData)
    })
    .then((response) => {
      if (!response.ok ){
        setLoading(false);
        throw new Error('status is not 200');
      }
      return response.json();
    })
    .then(jsondata => {
      setLoading(false);
      const i = reload+1;
      setReload(i);
      table.setCreatingRow(false)
    })
    .catch(error => {
      setLoading(false);
    });
    setLoading(false);
    }catch{
      setLoading(false);
    }

  };
  
  //UPDATE action
  const handleSaveUser: MRT_TableOptions<Notice>['onEditingRowSave'] = async ({
    values,
    table,
    row
  }) => {
    const newValidationErrors = validateUser(values);
    if (Object.values(newValidationErrors).some((error) => error)) {
      setValidationErrors(newValidationErrors);
      return;
    }
    setValidationErrors({});
    const url = process.env.REACT_APP_SEO_API_URL;
    try{
    const bodyData = {
      category: "18",
      _id:row.original._id,
      disp_type:values.disp_type,
      keyword:values.keyword
    };
  var getParams = new URLSearchParams(params);
   const headers = new Headers({
            "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
            'Access-Control-Allow-Credentials': 'true'
        });
  var params_str = params.toString();
  setLoading(true);
  return fetch(url , {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(bodyData)
    })
    .then((response) => {
      if (!response.ok ){
        setLoading(false);
        throw new Error('status is not 200');
      }
      return response.json();
    })
    .then(jsondata => {
      setLoading(false);
            const i = reload+1;
      setReload(i);
      table.setEditingRow(null);
    })
    .catch(error => {
      setLoading(false);
    });
    setLoading(false);
    }catch{
      setLoading(false);
    }

  };

  //DELETE action
  const openDeleteConfirmModal = (row: MRT_Row<Notice>) => {
    if (window.confirm('本当に削除してもよろしいでしょうか')) {
          const url = process.env.REACT_APP_SEO_API_URL;
    try{
    const bodyData = {
      category: "19",
      _id:row.original._id
    };
  var getParams = new URLSearchParams(params);
   const headers = new Headers({
            "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
            'Access-Control-Allow-Credentials': 'true'
        });
  var params_str = params.toString();
  setLoading(true);
  return fetch(url , {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(bodyData)
    })
    .then((response) => {
      if (!response.ok ){
        setLoading(false);
        throw new Error('status is not 200');
      }
      return response.json();
    })
    .then(jsondata => {
      setLoading(false);
            const i = reload+1;
      setReload(i);
    })
    .catch(error => {
      setLoading(false);
    });
    setLoading(false);
    }catch{
      setLoading(false);
    }
    }
  };
  const options = [
  { value: 'home', label: 'ホーム画面' },
  { value: 'column', label: 'コラム画面' },
  { value: 'columndetail', label: 'コラム詳細画面' },
  { value: 'news', label: 'ニュース画面' },
  { value: 'notification', label: 'お知らせ画面' }, 
  ];
  const options2 = [
  { value: "true", label: '公開' },
  { value: "false", label: '非公開' },
];


    const columns = useMemo<MRT_ColumnDef<Notice>[]>(
    //column definitions...
    () => [
      {
        accessorKey: 'disp_type',
        header: '画面',
        size: 50,
        grow: false,
        editVariant: 'select',
        editSelectOptions: options,
        muiEditTextFieldProps: {
          select: true,
          defaultValue:'info',
          sx:{ width: 1/4,display: 'flex', }
        },
      },
      {
        accessorKey: 'keyword',
        header: 'キーワード',
        size: 250,
        grow: false,
        muiEditTextFieldProps: {
          sx:{ width: 1/2 }
        },
      },
    ],
    [posts],
  );
  
  const data = posts
  const table = useMaterialReactTable({
    columns,
    data,
  enableEditing: true,
  createDisplayMode: 'modal',
  editDisplayMode: 'modal', //default ('row', 'cell', 'table', and 'custom' are also available)
  onCreatingRowSave: handleCreateUser,
    onCreatingRowCancel: () => {
    //clear any validation errors
  },
   onEditingRowCancel: () => setValidationErrors({}),
    onEditingRowSave: handleSaveUser,
  positionCreatingRow: 'top', //default is 'top'
    defaultColumn: {
     // minSize: 1100,
    // width:"100%"
    },
    enableDensityToggle: false,
    enableColumnResizing:false,
    enableFullScreenToggle: false,
    enableColumnFilters: false,
    enableClickToCopy: false,
    enableColumnDragging: false,
    enableColumnFilter: false,
    enableColumnOrdering: false,
    enableGlobalFilter: false,
    enableGrouping: false,
    enableHiding: false,
    enableResizing: false,
    paginationDisplayMode:'pages',
    enableSorting: false,
    autosizeColumns:"none",
    localization: locale,
    muiEditRowDialogProps:{
          maxWidth:'xl'
        },
    initialState: {
      density: 'compact',
      pagination: { pageIndex: 0, pageSize: 10 },
    },
    muiDetailPanelProps: () => ({
    }),
    //custom expand button rotation
    muiExpandButtonProps: ({ row, table }) => ({
      onClick: () => table.setExpanded({ [row.id]: !row.getIsExpanded() }), //only 1 detail panel open at a time
      sx: {
      },
    }),
    renderCreateRowDialogContent: ({ table, row, internalEditComponents }) => (
      <>
        <DialogTitle variant="h3">追加</DialogTitle>
        <DialogContent
          sx={{ display: 'flex', flexDirection: 'row', gap: '1rem',flexWrap:'wrap' }}
        >
          {internalEditComponents} {/* or render custom edit components here */}
        </DialogContent>
        <DialogActions>
          {/* <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              setNoticeTitle(row._valuesCache.title);
              setNoticeMsg(row._valuesCache.content);
              setNoticeDate(row._valuesCache.start_date);
              setNoticeMsgOpen(true);
              }}
      >
            プレビュー
          </Button> */}
          <MRT_EditActionButtons variant="text" table={table} row={row} />
        </DialogActions>
      </>
    ),
        //optionally customize modal content
    renderEditRowDialogContent: ({ table, row, internalEditComponents }) => (
      <>
        <DialogTitle variant="h3">更新</DialogTitle>
        <DialogContent
          sx={{ display: 'flex',flexDirection: 'row', gap: '1rem',flexWrap:'wrap' }}
        >
          {internalEditComponents} {/* or render custom edit components here */}
        </DialogContent>
        <DialogActions>
          <MRT_EditActionButtons variant="text" table={table} row={row} />
        </DialogActions>
      </>
    ),
    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: 'flex', gap: '1rem' }}>
        <Tooltip title="Edit">
          <IconButton onClick={() => table.setEditingRow(row)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete">
          <IconButton color="error" onClick={() => openDeleteConfirmModal(row)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </Box>
    ),
    renderTopToolbarCustomActions: ({ table }) => (
      <Button
        variant="contained"
        onClick={() => {
          table.setCreatingRow(true); //simplest way to open the create row modal with no default values
          //or you can pass in a row object to set default values with the `createRow` helper function
          // table.setCreatingRow(
          //   createRow(table, {
          //     //optionally pass in default values for the new row, useful for nested data or other complex scenarios
          //   }),
          // );
        }}
      >
        追加
      </Button>
    ),
  });


  return (
    <Box noWrap
      id="hero"
      sx={(theme) => ({
        //width: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundImage:
          'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 90%), transparent)',
        ...theme.applyStyles('dark', {
          backgroundImage:
            'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 16%), transparent)',
        }),
      })}
    ><div className={auth ? '' : 'hidden'} style={{ visibility: auth ? "visible" : "hidden" }}>
      <Container maxWidth="xl"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: { xs: 0, sm: 13 },
          pb: { xs: 0, sm: 0 },
        }}
      > 
            <InputLabel htmlFor="email-hero" sx={visuallyHidden} >
            </InputLabel>
            {/* <Container maxWidth={false}>
            <TextField
              id="email-hero"
              hiddenLabel
              fullWidth
              variant="outlined"
              placeholder="キーワード検索（#を付けて検索するとタグを検索します）"
              //value={location.state["keyword"]}
              defaultValue={keyword}
              autoComplete= 'off'
              InputProps={{ endAdornment: <AddButton /> }}
              onChange={handleChangeInput}
              sx={{ height:60}}
              onKeyDown={e => {
                  reloadChange();
              }}
            />
            <div>
            </div>
            </Container> */}
            <Typography
            sx={{
              display: { xs: 'none', md: 'flex' },
              gap: 0.5,
              textAlign: 'center',
              color: 'text.secondary',
              width: { sm: '100%', md: '80%' },
            }}
          >

          </Typography>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1}
            useFlexGap
            sx={{ pt: 2, width: { xs: '100%', sm: 'auto' } }}
          ></Stack>
            <Link hidden id="sc" to={"/search?"+getParams} state={{keyword:keyword,category:category}}>テキスト</Link>
      </Container>
    <input type="hidden" name="recaptcha_response" id="recaptchaResponse"></input>
    <Container maxWidth="xl"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
      <br/>
      <Container maxWidth="xl"
        sx={{
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Typography variant="h5" gutterBottom><FormattedMessage id = "langID00082"/></Typography>
        <Link hidden id="createColumn" to={"/ColumnDetail"} state={{keyword:keyword,category:"new",bf:"ad",table:{none:"none"}}}>テキスト</Link>
      </Container>
    <MaterialReactTable noWrap table={table}   />
    </Container>
    </div>
    </Box>
  );
}